import { inject, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IdentityAccountOnlyGuard } from "./guards";

const routes: Routes = [
  {
    path: "",
    canActivate: [() => inject(IdentityAccountOnlyGuard).canActivate()],
    runGuardsAndResolvers: "always",
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("./modules/home/home.module").then((m) => m.HomeModule),
        pathMatch: "full"
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        pathMatch: "full"
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./modules/settings/settings.module").then(
            (m) => m.SettingsModule
          )
      },
      {
        path: "console",
        loadChildren: () =>
          import("./modules/console/console.module").then(
            (m) => m.ConsoleModule
          )
      },
      {
        path: "past-meetings",
        loadChildren: () =>
          import("./modules/past-meetings/past-meetings.module").then(
            (m) => m.PastMeetingsModule
          ),
        pathMatch: "full"
      },
      {
        path: "**",
        redirectTo: "home"
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
